<template>
  <div class="count-down" v-if="pictures" :style="{order:h5ConfigDetails[0]['modalOrder']['CountDownOrder'][0]}">
    <img class="coupon-bg" :src="`${baseUrl.portalImg}${h5ConfigImgPath}/${pictures.countDownBg[0]}`" alt="">
    
    <div class="countdown-time" :style="`color:${pictures.countDownTxtColor[0]}`">
      <div class="time-block">
        <span :style="`background:${pictures.textBg[0]}`" class="time-digit">{{timeDigits.hours[0]}}</span>
        <span :style="`background:${pictures.textBg[0]}`" class="time-digit">{{timeDigits.hours[1]}}</span>
      </div>
      <div :style="`color:${pictures.colonColor[0]}`" class="colon">:</div>
      <div class="time-block">
        <span :style="`background:${pictures.textBg[0]}`" class="time-digit">{{timeDigits.minutes[0]}}</span>
        <span :style="`background:${pictures.textBg[0]}`" class="time-digit">{{timeDigits.minutes[1]}}</span>
      </div>
      <div :style="`color:${pictures.colonColor[0]}`" class="colon">:</div>
      <div class="time-block">
        <span :style="`background:${pictures.textBg[0]}`" class="time-digit">{{timeDigits.seconds[0]}}</span>
        <span :style="`background:${pictures.textBg[0]}`" class="time-digit">{{timeDigits.seconds[1]}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { baseUrl } from '@/config/env'

export default {
  name: 'CountDown',
  data() {
    return {
      baseUrl,
      pictures: null,
      timeRemaining: this.calculateTimeRemaining(),
    };
  },
  computed: {
    ...mapState(['h5ConfigDetails', 'h5ConfigImgPath']),
    timeDigits() {
      const hours = String(Math.floor(this.timeRemaining / 3600)).padStart(2, "0")
      const minutes = String(Math.floor((this.timeRemaining % 3600) / 60)).padStart(2, "0")
      const seconds = String(this.timeRemaining % 60).padStart(2, "0")

      return {
        hours: hours.split(""), // 分割小时为单个数字
        minutes: minutes.split(""), // 分割分钟为单个数字
        seconds: seconds.split(""), // 分割秒钟为单个数字
      }
    }
  },
  methods: {
    calculateTimeRemaining() {
      const now = new Date();
      const midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0);
      return Math.floor((midnight - now) / 1000);
    },
    updateCountdown() {
      this.timeRemaining = this.calculateTimeRemaining();
    }
  },
  mounted() {
    this.pictures = this.h5ConfigDetails[0].countDownPicture

    this.timer = setInterval(this.updateCountdown, 1000); // 每秒更新
  },
  beforeDestroy() {
    clearInterval(this.timer); // 组件销毁时清理定时器
  }
}
</script>

<style scoped lang="less">
  .count-down {
    position: relative;
    .coupon-bg {
      width: 100%;
      height: auto;
    }

    .countdown-time {
      height: 2.1rem;
      position: absolute;
      right: 4.5rem;
      bottom: 2rem;
      font-weight: 700;
      font-size: 1.6rem;
      display: flex;

      .colon {
        color: #fff;
        margin: 0 .2rem;
      }

      .time-block {
        position: relative;
        width: 3.2rem;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        .time-digit {
          display: block;
          background: aliceblue;
          height: 2.1rem;
          width: 1.5rem;
          border-radius: .3rem;
          text-align: center;
          line-height: 2.1rem;
        }
        .time-digit:last-child {
          margin-left: 1px;        
        }
      }
    }

  }
</style>